import { Theme } from '@emotion/react';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    flexDirection: 'column',
  },
  title: {
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: 1.4,
    mb: '4px',
  },
  tagLabel: {
    fontSize: 14,
    fontWeight: '500',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
